import gql from 'graphql-tag'

export const dateFormat = "DD/MM/YYYY HH:mm:ss"

export const LISTS = gql`
  query {
    lists {
      personLists {
        uuid, count, listData
      }
      descriptorLists {
        uuid, count, listData
      }
    }
  }
`
export const DESCRIPTOR_LISTS = gql`
  query DescriptorLists($offset: Int, $limit: Int) {
    descriptorsLists(offset: $offset, limit: $limit) {
      count
      items {
        uuid,
        listData
      }
    }
  }
`
export const PERSON_LISTS = gql`
  query PersonLists($offset: Int, $limit: Int) {
    personsLists(offset: $offset, limit: $limit) {
      count
      items {
        uuid,
        listData
      }
    }
  }
`
export const LIST = gql`
  query List($uuid: String!, $offset: Int, $limit: Int) {
    list(uuid: $uuid, offset: $offset, limit: $limit) {
      uuid
      listData
      count
      persons {
        uuid
        portrait
      }
      descriptors {
        uuid
        portrait
      }
    }
  }
`

export const PERSONS = gql`
  query Persons($offset: Int, $limit: Int) {
    persons(offset: $offset, limit: $limit) {
      count
      items {
        uuid
        portrait
        userData
        externalId
        descriptors(limit: 20) {
          uuid
          portrait
        }
      }
    }
  }
`

export const PANEL_PERSONS = gql`
  query Persons($offset: Int, $limit: Int) {
    persons(offset: $offset, limit: $limit) {
      count
      items {
        uuid
        portrait
        userData
        descriptors {
          uuid
        }
        lists {
          uuid
        }
      }
    }
  }
`

export const PERSON = gql`
  query Person($uuid: String!, $offset: Int, $limit: Int) {
    person(uuid: $uuid) {
      uuid
      externalId
      userData
      createTime(format: "${dateFormat}")
      portrait
      descriptorsCount
      descriptors(offset: $offset, limit: $limit) {
        uuid
        portrait
      }
      lists {
        uuid
        listData
      }
    }
  }
`

export const DESCRIPTORS = gql`
  query Descriptors($offset: Int, $limit: Int) {
    descriptors(offset: $offset, limit: $limit) {
      count
      items {
        uuid
        portrait
      }
    }
  }
`

export const PANEL_DESCRIPTORS = gql`
  query Descriptors($offset: Int, $limit: Int) {
    descriptors(offset: $offset, limit: $limit) {
      count
      items {
        uuid
        portrait
        person {
          uuid
        }
        lists {
          uuid
        }
      }
    }
  }
`

export const DESCRIPTOR = gql`
  query Descriptor($uuid: String!) {
    descriptor(uuid: $uuid) {
      uuid
      lastUpdate(format: "${dateFormat}")
      portrait
      lists {
        uuid
        listData
      }
      person {
        uuid
        userData
        portrait
      }
    }
  }
`

export const TOKENS = gql`
  query Tokens($offset: Int, $limit: Int) {
    account {
      tokens(offset: $offset, limit: $limit) {
        count
        items {
          uuid
          tokenData
        }
      }
    }
  }
`

export const TOKEN = gql`
  query Token($uuid: String!) {
    token(uuid: $uuid) {
      uuid
      tokenData
    }
  }
`

export const MATCH = gql`
  query Match($descriptorId: String, $personId: String, $listId: String, $descriptorIds: [String], $limit: Int) {
    match(
      descriptorId: $descriptorId, personId: $personId,
      listId: $listId, descriptorIds: $descriptorIds, limit: $limit
    ) {
      descriptor {
        uuid
        portrait
        lastUpdate(format: "${dateFormat}")
        person {
          portrait
          uuid
          userData
        }
      }
      similarity
    }
  }
`

export const IDENTIFY = gql`
  query Identify($descriptorId: String, $personId: String, $listId: String, $personIds: [String], $limit: Int) {
    identify(
      descriptorId: $descriptorId, personId: $personId,
      listId: $listId, personIds: $personIds, limit: $limit
    ) {
      similarity
      person {
        uuid
        userData
        createTime(format: "${dateFormat}")
        portrait
        descriptors {
            uuid
            portrait
        }
      }
    }
  }
`

export const VERIFY_FACE = gql`
  query VerifyFace($descriptorId: String, $personId: String) {
    verify(descriptorId: $descriptorId, personId: $personId) {
      similarity
      person {
        uuid
        userData
        createTime(format: "${dateFormat}")
        portrait
        descriptors {
          uuid
          portrait
        }
      }
    }
  }
`

export const CHECK_ACCOUNT = gql`
  query {
    account {
      email
      organizationName      
    }
  }
`

export const SEARCH = gql`
  query Search($query: String!) {
    search(query: $query) {
      __typename
      ...on Descriptor {
        uuid
      }
      ...on Person {
        uuid
      }
      ...on PersonsPaginatedList {
        items {
          uuid
          portrait
          userData
          externalId
          descriptors(limit: 20) {
            uuid
            portrait
          }
        }
      }
    }
  }
`

// mutations

export const SignInMutation = gql`
    mutation SignIn($password: String $login: String) {
        login(password: $password login: $login) {
            ok
            email
            organizationName
        }
    }
`

export const LogOutMutation = gql`
    mutation {
      logout {
        ok
      }
    }
`

export const SignUpMutation = gql`
  mutation SignUp($password: String! $email: String! $organizationName: String!) {
    registerAccount(password: $password email: $email organizationName: $organizationName) {
      token
      account {
        email
        organizationName
      }
    }
  }
`

export const CreatePersonMutation = gql`
  mutation CreatePerson($userData: String) {
    createPerson(userData: $userData) {
      personId
      userData
    }
  }
`

export const UpdatePersonMutation = gql`
  mutation UpdatePerson($uuid: String!, $userData: String, $externalId: String) {
    updatePerson(uuid: $uuid, userData: $userData, externalId: $externalId) {
      ok
    }
  }
`

export const DeletePersonMutation = gql`
  mutation DeletePerson($uuid: String!) {
    deletePerson(uuid: $uuid) {
      ok
    }
  }
`

export const CreateTokenMutation = gql`
  mutation CreateToken($tokenData: String!) {
    createToken(tokenData: $tokenData) {
      token {
        uuid
        tokenData
      }
    }
  }
`

export const UpdateTokenMutation = gql`
  mutation UpdateToken($tokenId: String!, $tokenData: String!) {
    updateToken(tokenId: $tokenId, tokenData: $tokenData) {
      ok
    }
  }
`

export const RemoveTokenMutation = gql`
    mutation RemoveToken($tokenId: String!) {
        removeToken(tokenId: $tokenId) {
            ok
        }
    }
`

export const AttachDescriptorToPerson = gql`
  mutation AttachDescriptorToPerson($descriptorUUIDs: [String]!, $personUUID: String!) {
    attachDescriptorToPerson(descriptorUUIDs: $descriptorUUIDs, personUUID: $personUUID) {
      ok
    }
  }
`

export const DetachDescriptorFromPerson = gql`
  mutation DetachDescriptorFromPerson($descriptorUUIDs: [String]!, $personUUID: String!) {
    detachDescriptorFromPerson(descriptorUUIDs: $descriptorUUIDs, personUUID: $personUUID) {
      ok
    }
  }
`

export const AttachPersonToList = gql`
  mutation AttachPersonToList($listUUID: String!, $personUUIDs: [String]!) {
    attachPersonToList(listUUID: $listUUID, personUUIDs: $personUUIDs) {
      ok
    }
  }
`

export const DetachPersonFromList = gql`
  mutation DetachPersonFromList($listUUID: String!, $personUUIDs: [String]!) {
    detachPersonFromList(listUUID: $listUUID, personUUIDs: $personUUIDs) {
      ok
    }
  }
`

export const AttachListToPerson = gql`
  mutation AttachListToPerson($listUUIDs: [String]!, $personUUID: String!) {
    attachListToPerson(listUUIDs: $listUUIDs, personUUID: $personUUID) {
      ok
    }
  }
`

export const DetachListFromPerson = gql`
  mutation DetachListFromPerson($listUUIDs: [String]!, $personUUID: String!) {
    detachListFromPerson(listUUIDs: $listUUIDs, personUUID: $personUUID) {
      ok
    }
  }
`

export const AttachDescriptorToList = gql`
    mutation AttachDescriptorToList($descriptorUUIDs: [String]!, $listUUID: String!) {
        attachDescriptorToList(descriptorUUIDs: $descriptorUUIDs, listUUID: $listUUID) {
            ok
        }
    }
`

export const DetachDescriptorFromList = gql`
    mutation DetachDescriptorFromList($descriptorUUIDs: [String]!, $listUUID: String!) {
        detachDescriptorFromList(descriptorUUIDs: $descriptorUUIDs, listUUID: $listUUID) {
            ok
        }
    }
`

export const AttachListToDescriptor = gql`
    mutation AttachListToDescriptor($descriptorUUID: String!, $listUUIDs: [String]!) {
        attachListToDescriptor(descriptorUUID: $descriptorUUID, listUUIDs: $listUUIDs) {
            ok
        }
    }
`

export const DetachListFromDescriptor = gql`
    mutation DetachListFromDescriptor($descriptorUUID: String!, $listUUIDs: [String]!) {
        detachListFromDescriptor(descriptorUUID: $descriptorUUID, listUUIDs: $listUUIDs) {
            ok
        }
    }
`

export const CreateList = gql`
  mutation CreateList($listData: String!, $type: ListTypeEnum!) {
    createList(listData: $listData, type: $type) {
      listId
      listData
    }
  }
`

export const UpdateListMutation = gql`
  mutation UpdateList($uuid: String!, $listData: String) {
    updateList(uuid: $uuid, listData: $listData) {
      ok
    }
  }
`

export const DeleteListMutation = gql`
  mutation DeleteList($uuid: String!) {
    deleteList(uuid: $uuid) {
      ok
    }
  }
`



// WEBPACK FOOTER //
// ./src/queries/index.js